import React, { useState, useEffect } from "react";
import profile from "../component/img/profile.jpg";
import axios from "axios";
import { baseurl } from "../Baseurl";

const ProductReview = ({ productid }) => {
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [reviews, setReviews] = useState([]); // State to store fetched reviews
  const cust_id = localStorage.getItem("cust_id");

  const handleRatingClick = (selectedRating) => {
    setRating(selectedRating);
  };

  const [ratingCounts, setRatingCounts] = useState({
    rating_1: "0",
    rating_2: "0",
    rating_3: "0",
    rating_4: "0",
    rating_5: "0"
  });
  
  const fetchReviews = async () => {
    try {
      const response = await axios.get(`${baseurl}getReviews/${productid}`);
      // console.log("Fetched reviews response:", response); 
      if (response.data.success) {
        setReviews(response.data.reviews);
        setRatingCounts(response.data.rating_counts); // Store rating counts
      } else {
        setMessage("Failed to load reviews.");
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setMessage("Error fetching reviews. Please try again.");
    }
  };
  

  useEffect(() => {
    fetchReviews();
  }, [cust_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0 || reviewText.trim() === "") {
      setMessage("Please provide both rating and review.");
      return;
    }

    setLoading(true);
    setMessage("");

    const reviewData = {
      cust_id,
      productid,
      rating,
      review: reviewText,
    };

    try {
      const response = await axios.post(`${baseurl}submit-review`, reviewData);

      if (response.data.success) {
        setMessage("Review submitted successfully!");
        setRating(0);
        setReviewText("");
        fetchReviews(); // Fetch reviews again to update the list
      } else {
        setMessage("Failed to submit review. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      setMessage("Error submitting review. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="row m-0 p-0 g-3 product-review-container">
      <div className="col-md-6 rating-summary">
        <div className="reviewcls mb-3">
          <h4 className="rating-heading">4.00 out of 5 Stars</h4>
          <div className="rating-progress">
  {[5, 4, 3, 2, 1].map((rating) => {
    const count = ratingCounts[`rating_${rating}`] || "0"; // Get count for rating
    const totalReviews = Object.values(ratingCounts).reduce((sum, val) => sum + parseInt(val), 0);
    const percentage = totalReviews > 0 ? (parseInt(count) / totalReviews) * 100 : 0; 

    return (
      <div key={rating} className="d-flex align-items-center mb-2">
        <span className="rating-label">{rating} Stars</span>
        <div className="progress flex-grow-1 mx-2">
          <div
            className="progress-bar"
            style={{ width: `${percentage}%` }}
            role="progressbar"
            aria-valuenow={percentage}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <span className="rating-count">{count} Reviews</span>
      </div>
    );
  })}
</div>

        </div>

        {/* Display fetched reviews */}
        {reviews.map((review) => (
          <div className="reviewcls" key={review.id}>
            <div className="d-flex align-items-center">
              <div className="me-2">
                <img
                  src={profile}
                  className="img-fluid profileimgrv"
                  alt="User"
                />{" "}
                &nbsp;
              </div>
              <div className="rvttl">
                <div className="mb-3 d-flex justify-content-between">
                  <div className="rvttl1">
                    {review.first_name} {review.last_name} –{" "}
                    {new Date(review.created_at).toLocaleDateString()}
                  </div>
                  <div>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i
                        key={star}
                        className={`fa fa-star fa-sm me-1 ${
                          review.rating >= star ? "text-warning" : "text-muted"
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
                <div className="rvttl2">{review.review_text}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="col-md-6">
        <div className="reviewcls">
          <h4 className="review-form-heading">Add a Review</h4>
          <p className="payttl">
            Please give rating and review for this product.
          </p>
          <hr />
          {message && <p className="alert alert-info">{message}</p>}
          <form className="review-form text-start" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="rating" className="form-label">
                Your Rating
              </label>
              <div className="d-flex align-items-center">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className={`fa fa-star mx-1 ${
                      rating >= star ? "text-warning" : "text-muted"
                    }`}
                    role="button"
                    onClick={() => handleRatingClick(star)}
                  ></i>
                ))}
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="review" className="form-label">
                Your Review
              </label>
              <textarea
                id="review"
                className="form-control"
                rows="4"
                placeholder="Write your review here"
                value={reviewText}
                onChange={(e) => setReviewText(e.target.value)}
              ></textarea>
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Review"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductReview;
